// extracted by mini-css-extract-plugin
export default {"container":"vnuM7xKQuldaEXABM3sP","title":"pqaPRxiyEqbfkCBvpKSS","descriptionContainer":"LFSHhKTkPAqJ6hcJULvu","description":"c_AXismmoGtevJY92CIm","pulse":"dtFlX4ZiNT84Tj_POGGH"};